import $ from 'jquery';

$(() => {
  const newDeliveryState = $('#checkout-new-address-state');
  const newDeliveryCountry = $('#checkout-new-address-country');
  const newBillingState = $('#checkout-new-address-country-billing');
  const newBillingCountry = $('#checkout-new-address-state-billing');

  function isFormValid() {
    const checkedRadios = $('.current .checkout-address .option-wrapper > [type="radio"]');
    const submitButton = $('.checkout-address [type="submit"]');
    let flag = true;
    let arr = [];// eslint-disable-line prefer-const
    $(checkedRadios).each((index) => {
      if ($(checkedRadios[index]).is(':checked')) {
        arr.push($(checkedRadios[index]));
      }
    });
    $.each(arr, (index) => {
      if (!(arr[index].closest('.option-wrapper').hasClass('success'))) {
        flag = false;
      }
    });
    if (flag) {
      $(submitButton).removeAttr('disabled');
    } else {
      $(submitButton).attr('disabled', '');
    }
  }

  function validateVisibleDepend(element) {
    const fieldsParent = $(element).find('.visible-depend');
    if ($(fieldsParent).children('.valid').not('.optional').length === $(fieldsParent).children('.panel-section').not('.optional').length) {
      $(fieldsParent).closest('.option-wrapper').addClass('success');
    } else {
      $(fieldsParent).closest('.option-wrapper').removeClass('success');
    }
  }

  $('.checkout-address input[type="text"]').on('blur', function (e) {
    const elem = e.target.closest('fieldset');
    const elemPanelSection = $(this).closest('.panel-section').not('.optional');

    if ($(this).val() === '') {
      elemPanelSection.removeClass('valid');
      elemPanelSection.addClass('invalid');
    } else {
      elemPanelSection.removeClass('invalid');
      elemPanelSection.addClass('valid');
    }

    validateVisibleDepend(elem);
    isFormValid();
  });

  $('#checkout-existing-address-select').selectize({
    create: true,
    onChange: (value) => {
      if (value !== '0') {
        $('#checkout-existing-address-select').closest('.option-wrapper').addClass('success');
      } else {
        $('#checkout-existing-address-select').closest('.option-wrapper').removeClass('success');
      }
      isFormValid();
    },
  });

  function panelSectionState(selectValue, elem) {
    if (selectValue === '0') {
      elem.closest('.panel-section').removeClass('valid');
      elem.closest('.panel-section').addClass('invalid');
    } else {
      elem.closest('.panel-section').removeClass('invalid');
      elem.closest('.panel-section').addClass('valid');
    }
  }

  newDeliveryState.selectize({
    create: true,
    onChange: (value) => {
      panelSectionState(value, newDeliveryState);
      validateVisibleDepend($('.delivery'));
      isFormValid();
    },
  });

  newDeliveryCountry.selectize({
    create: true,
    onChange: (value) => {
      panelSectionState(value, newDeliveryCountry);
      validateVisibleDepend($('.delivery'));
      isFormValid();
    },
  });

  newBillingState.selectize({
    create: true,
    onChange: (value) => {
      panelSectionState(value, newBillingState);
      validateVisibleDepend($('.billing'));
      isFormValid();
    },
  });

  newBillingCountry.selectize({
    create: true,
    onChange: (value) => {
      panelSectionState(value, newBillingCountry);
      validateVisibleDepend($('.billing'));
      isFormValid();
    },
  });

  $('.radio-label').on('click', () => {
    setTimeout(() => {
      isFormValid();
    }, 50);
  });

  $('#checkout-confirm').on('click', (e) => {
    const confirmButton = $(e.target).closest('.checkout-order-confirmation').find('.pane-footer form').children('.button');
    if ($(e.target).is(':checked')) {
      $(confirmButton).removeAttr('disabled');
    } else {
      $(confirmButton).attr('disabled', '');
    }
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/validate.js
 **/